/*
  Best Engravings: "This is a gift" box in the cart drawer (snippets/cart-drawer.liquid).

  Saves to /cart/update.js:
    attributes.Gift       "Yes" when on, "" (removed) when off
    attributes["Ship to"] "Me" | "Recipient" ("" when off)
  There is no card message (the studio does not add handwritten cards), and the cart note is never touched.

  The same values also sit in hidden inputs tied to #CartDrawer-Form, so the Checkout submit carries
  them even if a background save has not finished. paint() keeps them in sync.

  The drawer markup is replaced on every cart update (Section Rendering API), so every
  listener is delegated from `document`, and the initial state always comes from Liquid
  (cart.attributes). Saves never trigger a drawer re-render. If the drawer is re-rendered while a
  save is still in flight, the user's latest choices are re-applied to the fresh markup.
*/
(function () {
  if (window.BECartGift) return;

  var ERROR_TEXT = "We couldn't save that. Please try again.";

  var local = null; // latest state chosen by the user in this page view: { gift, shipTo }
  var queue = Promise.resolve();

  function updateUrl() {
    var base = (window.routes && window.routes.cart_update_url) || '/cart/update';
    return base.replace(/\.js$/, '') + '.js';
  }

  function boxFrom(el) {
    return el && el.closest ? el.closest('[data-be-gift]') : null;
  }

  function readState(box) {
    var toggle = box.querySelector('[data-be-gift-toggle]');
    var active = box.querySelector('[data-be-ship-to].is-active');
    return {
      gift: !!(toggle && toggle.checked),
      shipTo: active ? active.getAttribute('data-be-ship-to') : 'Recipient'
    };
  }

  function attributesFor(state) {
    return {
      Gift: state.gift ? 'Yes' : '',
      'Ship to': state.gift ? state.shipTo : ''
    };
  }

  function paint(box, state) {
    var toggle = box.querySelector('[data-be-gift-toggle]');
    var body = box.querySelector('[data-be-gift-body]');

    box.classList.toggle('is-on', state.gift);
    if (toggle) toggle.checked = state.gift;
    if (body) body.hidden = !state.gift;

    box.querySelectorAll('[data-be-ship-to]').forEach(function (btn) {
      var on = btn.getAttribute('data-be-ship-to') === state.shipTo;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    // Hidden inputs submitted with the Checkout button (form="CartDrawer-Form").
    var attrs = attributesFor(state);
    var giftInput = box.querySelector('[data-be-gift-attr="gift"]');
    var shipInput = box.querySelector('[data-be-gift-attr="ship-to"]');
    if (giftInput) giftInput.value = attrs.Gift;
    if (shipInput) shipInput.value = attrs['Ship to'];
  }

  function setStatus(text) {
    document.querySelectorAll('[data-be-gift-status]').forEach(function (el) {
      el.textContent = text;
    });
  }

  function save(body) {
    setStatus('');
    queue = queue
      .then(function () {
        return fetch(updateUrl(), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        });
      })
      .then(function (response) {
        if (!response.ok) throw new Error('cart update ' + response.status);
      })
      .catch(function () {
        setStatus(ERROR_TEXT);
      });
    return queue;
  }

  // Switch on / off
  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.matches || !target.matches('[data-be-gift-toggle]')) return;
    var box = boxFrom(target);
    if (!box) return;
    local = readState(box);
    paint(box, local);
    save({ attributes: attributesFor(local) });
  });

  // Ship to me / Ship to recipient
  document.addEventListener('click', function (event) {
    var btn = event.target && event.target.closest ? event.target.closest('[data-be-ship-to]') : null;
    if (!btn) return;
    var box = boxFrom(btn);
    if (!box) return;
    event.preventDefault();

    var state = readState(box);
    var next = btn.getAttribute('data-be-ship-to');
    if (state.shipTo === next && state.gift) return;
    state.shipTo = next;
    state.gift = true;
    local = state;
    paint(box, local);
    save({ attributes: attributesFor(local) });
  });

  // The drawer is re-rendered from the server on cart changes. The fresh markup can be older
  // than the user's last choice (a save still in flight), so put that choice back.
  function reapply() {
    if (!local) return;
    document.querySelectorAll('[data-be-gift]').forEach(function (box) {
      paint(box, local);
    });
  }

  function observe() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !window.MutationObserver) return;
    new MutationObserver(reapply).observe(drawer, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }

  window.BECartGift = { getState: function () { return local; } };
})();
